// src/UserModals/StopModal.jsx
import React, { useEffect, useState } from "react";
import ConfirmModal from "../CommonComponents/ConfirmModal";
import UserStateModal from "./UserStateModal";
import axios from "../../../utils/cmsAxios";

const API = (process.env.REACT_APP_FASTAPI_ADS_URL || "").replace(/\/+$/,"");

export default function StopModal({ open, onClose, target, getUserDetail, getSubLabel, onDone }) {
  const [detail, setDetail] = useState(null);
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open || !target?.user_id) return;
    let off = false;
    (async () => {
      try {
        const data = await getUserDetail(target.user_id);
        if (!off) setDetail(data || null);
      } catch { if (!off) setDetail(null); }
    })();
    return () => { off = true; setReason(""); };
  }, [open, target, getUserDetail]);

  const submit = async () => {
    if (!reason.trim()) return alert("정지 사유를 입력해주세요.");
    setSaving(true);
    try {
      const { data } = await axios.post(`${API}/ads/user/stop`, { user_id: target.user_id, reason });
      if (data?.success ?? true) { onDone?.(); onClose(); }
      else alert(data?.message || "정지 실패");
    } catch { alert("서버 오류로 정지 실패"); }
    finally { setSaving(false); }
  };

  return (
    <ConfirmModal
      open={open}
      title="회원 정지"
      onClose={() => !saving && onClose()}
      closeOnOverlay={false}
      message={
        <div className="space-y-3">
          <UserStateModal
            detail={detail}
            fallbackName={target?.nickname}
            subStatusLabel={getSubLabel(detail?.subscription_type)}
          />
          <hr className="border-neutral-200"/>
          <div className="space-y-2">
            <label className="text-sm text-neutral-600">회원 정지 사유</label>
            <textarea
              className="w-full h-28 rounded-md border border-neutral-300 px-3 py-2 text-sm"
              value={reason} onChange={(e)=>setReason(e.target.value)}
              placeholder="예) 부정 사용 의심"
            />
          </div>
        </div>
      }
      buttons={[
        { label: saving ? "정지 중..." : "회원 정지", intent:"primary", autoFocus:true, onClick: submit, disabled: saving || !reason.trim() },
        { label: "취소", onClick: () => !saving && onClose() },
      ]}
    />
  );
}
